const UserRoles = {
  ADMINISTRATOR: "I_Admin",
  OPERATION: "I_Operation",
  BILLING: "I_Billing",
  USER: "E_User",
};

export default UserRoles;
